<template>

    <table class="responsive-table fix-head">
        <thead>
        <tr>
            <th scope="col">&nbsp;</th>
            <th scope="col">Measure</th>
            <th scope="col">This Application</th>
            <th scope="col">Certificate</th>
            <th scope="col">Balance</th>
        </tr>
        </thead>
        <tbody>

        <tr>
            <td scope="row" data-label="Type">Works Complete</td>
            <td data-label="Measure">£{{ latest_measure.works | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ works | money }}</span>
                <input v-else type="number" step="0.01" v-model="works" name="works" value=""/>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.works | money }}</td>
            <td data-label="Balance">£{{ parseFloat(works - latest_certificate.works) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">Materials On Site</td>
            <td data-label="Measure">£{{ latest_measure.materials | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ materials | money }}</span>
                <input v-else type="number" step="0.01" v-model="materials" name="materials"
                                                     value=""/>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.materials | money }}</td>
            <td data-label="Balance">£{{ parseFloat(materials - latest_certificate.materials) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">Sum</td>
            <td data-label="Measure">£{{ latest_measure.sum | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ sum | money }}</span>
                <span v-else>
                    £{{ sum | money }}<input type="hidden" name="sum" :value="sum"/>
                </span>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.sum | money }}</td>
            <td data-label="Balance">£{{ parseFloat(sum - latest_certificate.sum) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">MCD</td>
            <td data-label="Measure">£{{ latest_measure.mcd | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ mcd | money }}</span>
                <input v-else type="number" step="0.01" name="mcd" v-model="mcd" value=""/>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.mcd | money }}</td>
            <td data-label="Balance">£{{ parseFloat(mcd - latest_certificate.mcd) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">Retention</td>
            <td data-label="Measure">£{{ latest_measure.retention | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ retention | money }}</span>
                <input v-else type="number" step="0.01" name="retention" v-model="retention"
                                                     value=""/>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.retention | money}}</td>
            <td data-label="Balance">£{{ parseFloat(retention - latest_certificate.retention) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">Net Valuation</td>
            <td data-label="Measure">£{{ latest_measure.net | money }}</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ net | money }}</span>
                <span v-else>
                    £{{ net_val | money }}<input type="hidden" name="net" :value="net_val"/>
                </span>
            </td>
            <td data-label="Certificate">£{{ latest_certificate.net | money}}</td>
            <td data-label="Balance">£{{ parseFloat(net_val - latest_certificate.net) | money}}</td>
        </tr>

        <tr>
            <td scope="row" data-label="Type">Balance Remaining Until Completion</td>
            <td data-label="Measure">&nbsp;</td>
            <td data-label="This Application">
                <span v-if="viewing">£{{ balance | money }}</span>
                <span v-else>
                    £{{ balance_remaining | money}}<input type="hidden" name="balance"
                                                                                    :value="balance_remaining"/>
                </span>
            </td>
            <td data-label="Certificate">&nbsp;</td>
            <td data-label="Balance">&nbsp;</td>
        </tr>

        </tbody>
    </table>

</template>

<script>
    export default {
        props: ['packageId', 'afpId'],
        data() {
            return {
                works: 0.00,
                materials: 0.00,
                mcd: 0.00,
                retention: 0.00,
                net: 0.00,
                balance: 0.00,
                latest_certificate: {
                    works: 0.00,
                    materials: 0.00,
                    sum: 0.00,
                    mcd: 0.00,
                    retention: 0.00,
                    net: 0.00
                },
                latest_measure: {
                    works: 0.00,
                    materials: 0.00,
                    sum: 0.00,
                    mcd: 0.00,
                    retention: 0.00,
                    net: 0.00
                }
            }
        },
        filters: {
            money: function (val) {
                var parsed = parseFloat(val).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                console.log('Parsing value from type to money',val,parsed);
                return parsed;
            }
        },
        watch: {
            latest_measure: function () {
                if(this.viewing){
                    return;
                }
                this.works = this.latest_measure.works;
                this.materials = this.latest_measure.materials;
                this.mcd = this.latest_measure.mcd;
                this.retention = this.latest_measure.retention;
            }
        },
        computed: {
            viewing: function () {
                if (this.afpId) {
                    return true;
                }

                return false;
            },
            sum: function () {
                var works = (isNaN(parseFloat(this.works)) ? 0.00 : parseFloat(this.works));
                var materials = (isNaN(parseFloat(this.materials)) ? 0.00 : parseFloat(this.materials));
                return parseFloat(works + materials).toFixed(2);
            },
            net_val: function () {
                var sum = (isNaN(parseFloat(this.sum)) ? 0.00 : parseFloat(this.sum));
                var mcd = (isNaN(parseFloat(this.mcd)) ? 0.00 : parseFloat(this.mcd));
                var retention = (isNaN(parseFloat(this.retention)) ? 0.00 : parseFloat(this.retention));

                return parseFloat(sum - (mcd + retention)).toFixed(2);
            },
            balance_remaining: function () {
                return 0.00;
            }
        },
        methods: {
            getAfp(){
                var that = this;
                var url = appUrls.afps.show.replace('REPLACEME',this.afpId);
                var params = {};

                axios.get(url)
                    .then(response => {
                        var afp = response.data.data;
                        that.works = parseMoney(afp.complete);
                        that.materials = parseMoney(afp.materials);
                        that.retention = parseMoney(afp.retention);
                        that.mcd = parseMoney(afp.mcd);
                        that.balance = parseMoney(afp.balance);
                        that.net = parseMoney(afp.net);
                    });
            },
            getCertificates() {
                var that = this;
                var url = appUrls.pcs.index;
                var params = {};

                if (this.packageId) {
                    params.package_id = this.packageId;
                } else {
                    console.warn('No Package ID Specified For AFP Table Component. This is a requirement.');
                }

                axios.get(url, {params: params})
                    .then(response => {
                        if (response.data.data.length) {
                            var latestCert = _.maxBy(response.data.data, 'application');

                            that.latest_certificate = {
                                works: latestCert.raw_costs.complete,
                                materials: latestCert.raw_costs.materials,
                                sum: latestCert.raw_costs.sum,
                                mcd: latestCert.raw_costs.mcd,
                                retention: latestCert.raw_costs.retention,
                                net: latestCert.raw_costs.net,
                            };

                        }
                    });
            },
            getMeasure() {
                var that = this;
                var url = appUrls.packages.measure.replace('REPLACEME', this.packageId);
                var params = {};

                axios.get(url, {params: params})
                    .then(response => {
                        if (response.data) {

                            that.latest_measure = {
                                works: response.data.works,
                                materials: response.data.materials,
                                sum: response.data.sum,
                                mcd: response.data.mcd,
                                retention: response.data.retention,
                                net: response.data.net,
                            };

                        }
                    });
            }
        },
        mounted() {
            this.getCertificates();
            this.getMeasure();
            if (this.afpId) {
                this.getAfp();
            }
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>